import { render } from "./SignUpBody.vue?vue&type=template&id=542efc28&scoped=true"
import script from "./SignUpBody.vue?vue&type=script&lang=js"
export * from "./SignUpBody.vue?vue&type=script&lang=js"

import "./SignUpBody.vue?vue&type=style&index=0&id=542efc28&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542efc28"]])

export default __exports__